var cov_1wmgjh9n1c = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/context.tsx",
      hash = "98d134c523bd5b605e84709e76e17a99376597af",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/context.tsx",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 16
        },
        end: {
          line: 5,
          column: 84
        }
      },
      "1": {
        start: {
          line: 7,
          column: 28
        },
        end: {
          line: 7,
          column: 35
        }
      },
      "2": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 10,
          column: 23
        }
      },
      "3": {
        start: {
          line: 10,
          column: 14
        },
        end: {
          line: 10,
          column: 23
        }
      },
      "4": {
        start: {
          line: 12,
          column: 28
        },
        end: {
          line: 12,
          column: 30
        }
      },
      "5": {
        start: {
          line: 13,
          column: 2
        },
        end: {
          line: 15,
          column: 4
        }
      },
      "6": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 45
        }
      },
      "7": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 28
        }
      },
      "8": {
        start: {
          line: 19,
          column: 25
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "9": {
        start: {
          line: 19,
          column: 117
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "10": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 24,
          column: 21
        }
      },
      "11": {
        start: {
          line: 23,
          column: 38
        },
        end: {
          line: 23,
          column: 94
        }
      }
    },
    fnMap: {
      "0": {
        name: "filterProps",
        decl: {
          start: {
            line: 9,
            column: 9
          },
          end: {
            line: 9,
            column: 20
          }
        },
        loc: {
          start: {
            line: 9,
            column: 75
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 9
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 13,
            column: 15
          },
          end: {
            line: 13,
            column: 16
          }
        },
        loc: {
          start: {
            line: 13,
            column: 20
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 13
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 25
          },
          end: {
            line: 19,
            column: 26
          }
        },
        loc: {
          start: {
            line: 19,
            column: 117
          },
          end: {
            line: 25,
            column: 1
          }
        },
        line: 19
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 19,
            column: 117
          },
          end: {
            line: 19,
            column: 118
          }
        },
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 24,
            column: 21
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 23,
            column: 5
          },
          end: {
            line: 23,
            column: 6
          }
        },
        loc: {
          start: {
            line: 23,
            column: 38
          },
          end: {
            line: 23,
            column: 94
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 23
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 23
          }
        }, {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 10,
            column: 23
          }
        }],
        line: 10
      },
      "1": {
        loc: {
          start: {
            line: 19,
            column: 98
          },
          end: {
            line: 19,
            column: 112
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 19,
            column: 110
          },
          end: {
            line: 19,
            column: 112
          }
        }],
        line: 19
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0],
      "1": [0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Card/context.tsx";

import React from 'react';
import createReactContext from '../context';
var context = (cov_1wmgjh9n1c.s[0]++, createReactContext({}));

var _ref = (cov_1wmgjh9n1c.s[1]++, context),
    Provider = _ref.Provider;

export { Provider };

function filterProps(props, keys) {
  cov_1wmgjh9n1c.f[0]++;
  cov_1wmgjh9n1c.s[2]++;

  if (!props) {
    cov_1wmgjh9n1c.b[0][0]++;
    cov_1wmgjh9n1c.s[3]++;
    return {};
  } else {
    cov_1wmgjh9n1c.b[0][1]++;
  }

  var value = (cov_1wmgjh9n1c.s[4]++, {});
  cov_1wmgjh9n1c.s[5]++;
  keys.forEach(function (k) {
    cov_1wmgjh9n1c.f[1]++;
    cov_1wmgjh9n1c.s[6]++;
    value[k] = props[k];
  });
  cov_1wmgjh9n1c.s[7]++;
  return value;
}

cov_1wmgjh9n1c.s[8]++;
export var consumer = function consumer(Origin) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1wmgjh9n1c.b[1][0]++, []);
  cov_1wmgjh9n1c.f[2]++;
  cov_1wmgjh9n1c.s[9]++;
  return function (props) {
    cov_1wmgjh9n1c.f[3]++;
    cov_1wmgjh9n1c.s[10]++;
    return (
      /*#__PURE__*/
      React.createElement(context.Consumer, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 22,
          columnNumber: 3
        }
      }, function (value) {
        cov_1wmgjh9n1c.f[4]++;
        cov_1wmgjh9n1c.s[11]++;
        return (
          /*#__PURE__*/
          React.createElement(Origin, Object.assign({}, props, filterProps(value, keys), {
            __self: _this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 23,
              columnNumber: 39
            }
          }))
        );
      })
    );
  };
};